import { DiscountAppliesTo, discountAppliesToOptions, ThresholdType } from '../../../models';
import { getRequirementsFromRequirementStepState } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';

export function useDiscountAppliesToOptions(): {
  disabledTooltip?: string;
  discountAppliesToOptions: { disabled?: boolean; name: string; val: DiscountAppliesTo }[];
} {
  const { requirementsStepState } = useDiscountWizardStateContext();

  const requirements = getRequirementsFromRequirementStepState(requirementsStepState);

  const noRequirementHasThreshold = Object.values(requirements).every(
    (requirement) => requirement.condition === ThresholdType.NoThreshold
  );

  if (noRequirementHasThreshold) {
    return {
      disabledTooltip: 'You must set a quantity, weight, or spend condition on the previous step to select this option',
      discountAppliesToOptions: discountAppliesToOptions.map((option) => ({
        ...option,
        disabled: option.val !== DiscountAppliesTo.SameProducts,
      })),
    };
  }

  const singleRequirementWithItemCondition =
    Object.keys(requirements).length === 1 && requirements[1]?.condition === ThresholdType.NumberOfItems;

  if (!singleRequirementWithItemCondition) {
    return {
      disabledTooltip: 'You must set an item quantity condition on the previous step to select this option',
      discountAppliesToOptions: discountAppliesToOptions.map((option) => ({
        ...option,
        disabled: [DiscountAppliesTo.HighestPricedItem, DiscountAppliesTo.LowestPricedItem].includes(option.val),
      })),
    };
  }

  return { discountAppliesToOptions };
}
